export const containerStyles = 'rounded-2xl flex flex-col gap-3'
export const titleStyles = 'text-md-medium'
export const fieldsContainerStyles = 'flex flex-col gap-3'
export const fieldRowStyles = 'flex justify-between items-center'
export const fieldLabelStyles = 'text-sm-regular'
export const fieldValueStyles = 'text-sm-medium'
export const dividerStyles = 'h-px w-full'
export const buttonContainerStyles = 'flex flex-col items-end gap-3'
export const notConfiguredContainerStyles =
   'py-8 rounded-2xl border flex flex-col gap-3'
export const notConfiguredInnerStyles = 'flex justify-center items-center gap-2'
export const notConfiguredTextContainerStyles = 'flex flex-col gap-2'
export const notConfiguredTitleStyles = 'text-sm-medium'
